import $ from 'jquery';
import 'slick-carousel';

const CLASS_GRID_SECTION = '.brandhub-grid-section';
const CLASS_SLICK_INITIALIZED = 'slick-initialized';

class BrandHubThumbTabs {
  tabElems = {};
  items = [];
  firstTabElem = {};
  btnGroupElem = {};
  visible = false;
  sliderOptions = {
    infinite: false,
    autoplay: false,
    dots: false,
    fade: false,
    rows: false,
    slide: 'button',
    variableWidth: true,
    centerMode: true,
    centerPadding: '80px',
    slidesToShow: 1,
    initialSlide: 1,
  };

  constructor (tabElems, items, firstTabElem) {
    this.tabElems = tabElems;
    this.items = items;
    this.firstTabElem = firstTabElem;
  }

  init () {
    this.renderTabs();
    // this.switchToTabItem(0, true)
  }

  static getGroup (item) {
    const group = [];
    const $elem = $(item);
    let parentElement = $elem.parent().parent();
    const prevElemIsGridWithTab = parentElement.prev().hasClass('grid') && parentElement.prev().find('.brandhub-thumb-tabs-item').length;
    if (!prevElemIsGridWithTab) {
      group.push(parentElement);
      while (parentElement.next().is('.grid') && parentElement.next().find('.brandhub-thumb-tabs-item').length) {
        group.push(parentElement.next());
        parentElement = parentElement.next();
      }
    }
    return group;
  }

  renderTabs () {
    let btnGroupContainerElem = $('<div class="brandhub-thumb-tabs-btn-group-container clearfix brandhub-grid-container" role="group"></div>');
    this.btnGroupElem = $('<div class="btn-group btn-group-sm brandhub-thumb-tabs-btn-group reveal-it brandhub-fade-in brandhub-from-bottom" role="group"></div>');
    this.btnGroupElem.appendTo(btnGroupContainerElem);
    let hasWhiteBg = false;
    let activeIndex = 0;
    const urlHash = window.location.hash.substr(1);
    $.each(this.items, (i, item) => {
      const btnElem = $(`<button class="brandhub-grid-tabs-btn">${item.headlineElem.html()}</button>`);
      if (item.anchor) {
        btnElem.attr('id', item.anchor);
      }
      btnElem.on('click', () => {
        this.switchToTabItem(i, false);
      });
      // eslint-disable-next-line no-param-reassign
      item.btnElem = btnElem;
      if (item.whiteBg) {
        hasWhiteBg = true;
      }
      btnElem.appendTo(this.btnGroupElem);
      if (item.anchor === urlHash) {
        activeIndex = i;
      }
    });

    if (this.firstTabElem.find(CLASS_GRID_SECTION).parent().hasClass('container-outer')) {
      btnGroupContainerElem = $('<div class="container-outer" />').append(btnGroupContainerElem);
      btnGroupContainerElem.insertBefore(this.firstTabElem.find(CLASS_GRID_SECTION).parent().parent());
    } else {
      btnGroupContainerElem.insertBefore(this.firstTabElem);
    }

    if (hasWhiteBg) {
      btnGroupContainerElem.addClass('background-white');
    }

    if (activeIndex === 0) {
      this.switchToTabItem(0, true);
    } else {
      this.switchToTabItem(activeIndex, false);
    }

    setTimeout(() => {
      const anchorElem = document.getElementById(urlHash);
      if (anchorElem) {
        anchorElem.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300);

    this.onResize();
    $(window).resize(this.onResize.bind(this));

    if (window.RevealIt) {
      window.RevealIt.reInit();
    }
  }

  onResize () {
    if ($(window).width() < 768) {
      if (!this.btnGroupElem.hasClass(CLASS_SLICK_INITIALIZED) && this.btnGroupElem.children().length > 2) {
        this.buildMobileNavigation();
      }
    } else {
      this.destroyMobileNavigation();
    }
  }

  buildMobileNavigation () {
    this.btnGroupElem.slick(this.sliderOptions);
  }

  destroyMobileNavigation () {
    if (this.btnGroupElem.hasClass(CLASS_SLICK_INITIALIZED)) {
      this.btnGroupElem.slick('unslick');
    }
  }

  switchToTabItem (index, initial) {
    if (this.btnGroupElem.hasClass(CLASS_SLICK_INITIALIZED) && !initial) {
      this.btnGroupElem.slick('slickGoTo', index, false);
    }

    $.each(this.items, (i, item) => {
      if (i === index) {
        item.elem.find(CLASS_GRID_SECTION).addClass('brandhub-thumb-tabs-item-active');
        item.btnElem.addClass('brandhub-thumb-tabs-btn-active');
        // trigger lazyLoadXT
        item.elem.lazyLoadXT();
        // handle card-transitiom
        setTimeout(() => {
          item.elem.find('.brandhub-thumb-item.brandhub-card-transition').addClass('view');
        }, 100);
      } else {
        item.elem.find(CLASS_GRID_SECTION).removeClass('brandhub-thumb-tabs-item-active');
        item.btnElem.removeClass('brandhub-thumb-tabs-btn-active');
        // handle card-transitiom
        item.elem.find('.brandhub-thumb-item.brandhub-card-transition').removeClass('view');
      }
    });
  }
}

$(document).ready(() => {
  const tabElems = $('*[data-js-init="brandhub-thumb-tabs"]');
  tabElems.each((index, item) => {
    if ($(item).hasClass('tab-initialized')) {
      return;
    }
    $(item).addClass('tab-initialized');

    const items = [];
    const group = BrandHubThumbTabs.getGroup(item);
    const firstTabElem = group[0];

    if (group.length > 0) {
      $(group).each((i, groupItem) => {
        const elem = $(groupItem);
        const anchorId = elem.find(CLASS_GRID_SECTION).attr('data-anchor-id') || null;
        const headlineElem = elem.find('.brandhub-thumb-tabs-headline');

        const newItem = {
          elem,
          headlineElem,
          btnElem: null,
          whiteBg: elem.find(CLASS_GRID_SECTION).hasClass('background-white'),
          anchor: anchorId,
        };
        items.push(newItem);
      });

      const tabs = new BrandHubThumbTabs(tabElems, items, firstTabElem);
      tabs.init();
    }
  });
});



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/components/grid/brandhub-thumb-tabs.js